/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Policy_Destructive_Confirm_ChangedInputs */



/**
* | output |
* | --- |
* | "The marked agents changed in the meantime. Review the updated list." |
*
* @param {Agent_Policy_Destructive_Confirm_ChangedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_policy_destructive_confirm_changed = /** @type {((inputs?: Agent_Policy_Destructive_Confirm_ChangedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Policy_Destructive_Confirm_ChangedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Die markierten Agenten haben sich inzwischen geändert. Prüfen Sie die aktualisierte Liste.")
	return /** @type {LocalizedString} */ ("The marked agents changed in the meantime. Review the updated list.")
});